import { Careers } from 'src/presentation/pages'

export const makeCareers = () => <Careers />
